// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1X4NN","balanceDisclaimer":"posDashboard_balanceDisclaimer__3wIif"};